import ImagePreview from "./ImagePreview";
import { useStore } from 'react-redux';
import computeFilters from './computeFilters';
import G from './Getters';
import O from './O';
import ReportMessage from './ReportMessage';
export default function ImageChangeInfo({selectedImageId,silenceUnadjusted, label}){


  const store = useStore();
  const state = store.getState();
  const image = G.getImage(state,{_id:selectedImageId});

  const filters = computeFilters(image.adjustments);

  

  if( Object.values(image.adjustments).every(x => x === 1 )){

    return (
      <div style={{marginBottom:50}} class="fair-margin">
        <ReportMessage type="success">
          No image adjustments detected.
        </ReportMessage>
        <h5 style={{textAlign:'center'}}>{label}</h5>
        <br/>


          <div style={{width:500}}>
            <ImagePreview filters={filters} imageId={selectedImageId}/>
          </div>

        

      </div>
    )
    
  }


  let hasAdjustments = Object.values(filters).some(x => x.length > 0 );

  let adjustments;




  if( hasAdjustments ){

    let adjustmentsInfo = (

      <div style={{width:100,

        background:"#f8d7da",
    color:"#58151c",
    border:"1px solid #f1aeb5",
    borderRadius:3,
    linkColor:"#58151c",

        }} class="fair-margin">
      {filters.filter.trim().split(' ').map(x => {
        let [key,val] = x.replace('(',' ').replace(')','').split(' ')
        if( !key ){ return; }

        let change = ((val-1)*100).toFixed(1);

        return (<div class="small-margin">
          <b>{key[0].toUpperCase() + key.slice(1)}</b>
          &nbsp;
          <div>{change > 0 && "+"}{change}%</div>
        </div>)
      })}
    </div>
    )




    return (
      <div style={{marginBottom:50}} class="fair-margin">
        <div style={{textAlign:'center', fontSize:24}}>{label}</div>
        <br/>
        <div class="sg-row">

         {adjustmentsInfo}

          <div style={{width:300}}>
            <div>As Shown In Figure</div>
            <ImagePreview filters={filters} imageId={selectedImageId}/>
          </div>
          
        </div>
        <div class="sg-row">
          <div class="fair-margin" style={{width:100}}/>
           <div style={{width:300}}>
            <div>Raw Upload</div>
            <ImagePreview imageId={selectedImageId}/>
          </div>


                  </div>
      </div>
    )
  }else{

     return (
      <h3 class="fair-margin">No enhancements made in Sciugo.</h3>
    )
  }


  

  return (
    <div>

      {adjustments}

    </div>
  )

}
